var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5848 2.84766H7.43999C5.99141 2.84766 4.70999 3.82345 4.48235 5.25451C3.73419 9.95521 3.98252 15.6492 4.59378 20.7861C4.74341 22.0293 6.21586 22.5801 7.1646 21.7619L9.16235 20.0427L10.6953 21.7141C10.9198 21.9586 11.1928 22.1536 11.497 22.2866C11.8011 22.4197 12.1296 22.4878 12.4615 22.4868C12.7934 22.4857 13.1215 22.4155 13.4248 22.2805C13.728 22.1456 13.9998 21.9489 14.2228 21.703L15.7271 20.0443L17.7949 21.8048C18.7404 22.6119 20.197 22.0723 20.353 20.8386C20.9977 15.759 21.3065 9.79125 20.4883 5.14945C20.2447 3.76615 18.9904 2.84766 17.5848 2.84766Z",
    stroke: "#D0CDD7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6779 9.07786C14.6779 9.07786 13.8597 8.16415 12.5321 8.27876C11.2045 8.39337 10.5646 9.20839 10.5646 10.0266C10.5646 12.4112 14.6779 10.7588 14.6779 13.2039C14.6779 14.4646 11.9495 15.3545 10.3242 13.8725M12.6945 6.67578V8.26762M12.6945 14.6318V16.2268",
    stroke: "#D0CDD7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.a499ee7d6285622c18a1124c15b43488.svg";
export { ForwardRef as ReactComponent };